const AboutSection = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/5519981868997', '_blank');
  };

  return (
    <section id="sobre-nos" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            Desentupidora da Cidade Nº1 24 Horas
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-green-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-800 mb-6">
              Entupiu? Resolvemos em 30 Minutos!
            </h3>

            <p className="text-gray-600 leading-relaxed">
              <strong>Emergência de desentupimento em Campinas e Região?</strong> Não deixe o problema se
              agravar! Nossa equipe especializada da Desentupidora da Cidade Nº1 atende{' '}
              <strong>24 horas por dia</strong> com equipamentos de última geração para
              desentupimento de pias, vasos sanitários, ralos e esgotos.
            </p>

            <p className="text-gray-600 leading-relaxed">
              <strong>Mais de 5 anos de experiência</strong> atendendo residências, comércios e
              indústrias em Campinas e Região. Nossos técnicos certificados utilizam hidrojateamento
              profissional e técnicas avançadas de desentupimento para garantir{' '}
              <strong>solução definitiva</strong> do seu problema.
            </p>

            <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
              <p className="text-blue-800 font-medium">
                ⚡ <strong>Atendimento 24h em Campinas e Região:</strong> Desentupimento de emergência todos
                os dias, inclusive finais de semana e feriados. Chegamos em até 30 minutos na sua
                região!
              </p>
            </div>

            <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
              <p className="text-green-800 font-medium">
                💰 <strong>Orçamento Gratuito:</strong> Avaliação sem compromisso e preços justos.
                Não cobre de outros? Igualamos qualquer orçamento da concorrência!
              </p>
            </div>

            <div className="bg-yellow-50 p-6 rounded-lg border-l-4 border-yellow-500">
              <p className="text-yellow-800 font-medium">
                🛡️ <strong>Garantia Total:</strong> Todos os nossos serviços de desentupimento
                possuem garantia. Se o problema voltar, retornamos gratuitamente!
              </p>
            </div>

            <button
              onClick={handleWhatsApp}
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-bold text-sm transition-all transform hover:scale-105 flex items-center space-x-1 whitespace-nowrap shadow-lg w-full sm:w-auto justify-center"
            >
              <i className="ri-whatsapp-line text-base"></i>
              <span>Orçamento Grátis</span>
            </button>
          </div>

          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-2xl">
              <img
                alt="Desentupidora da Cidade Nº1 - Serviços Profissionais"
                className="w-full h-full object-cover"
                src="https://public.readdy.ai/ai/img_res/6f13307f6e61dd235e9c2d9cad031cf1.jpg"
              />
            </div>
            <div className="absolute -top-4 -right-4 bg-yellow-400 text-black px-6 py-3 rounded-full font-bold shadow-lg transform rotate-12">
              <div className="text-center">
                <div className="text-sm">+ 5 ANOS</div>
                <div className="text-xs">EXPERIÊNCIA</div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-16">
          <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
            <strong>Desentupidora da Cidade Nº1 Campinas e Região</strong> - Empresa líder em desentupimento e
            hidrojateamento. Atendemos toda a região de Campinas e Região com{' '}
            <strong>técnicos especializados</strong> e equipamentos modernos. Seguimos rigorosamente
            as normas de segurança e nossos profissionais utilizam EPIs conforme legislação.
            <strong>Desentupimento 24 horas</strong> com chegada em até 30 minutos. Orçamento
            gratuito e parcelamento em até 10x sem juros.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;